import Vue from "vue";
import Vuex from "vuex";
//import axios from "axios";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    results: null,
    pagination: null
  },
  mutations: {
    SET_BUSINESS_UNITS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
    }
  },
  actions: {
    async loadBusinessUnits({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get("/admin/business-units", {
          params: params
        });
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_BUSINESS_UNITS", res.data);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async saveBusinessUnit({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.put(
          `/admin/business-units/${params.id}`,
          {
            name: params.name,
            ERPCode: params.ERPCode,
            groupName: params.groupName
          }
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async addBusinessUnit({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.post("/admin/business-units", {
          name: params.name,
          ERPCode: params.ERPCode,
          groupName: params.groupName
        });
        if (res.status != 201) throw errors.handleHTTPError(res);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async deleteBusinessUnit({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.delete(
          `/admin/business-units/${id}`
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
  },
  getters: {
    businessUnits: state => {
      const businessUnits = {
        results: state.results,
        pagination: state.pagination
      };
      return businessUnits;
    }
  }
};
